import { VerticalArrowKeys, KeyboardKeys } from 'constants/';
import { useContainerFocus } from 'CustomHooks/useContainerFocus';
import { useEventListener } from 'CustomHooks/useEventListener';
import React, { useRef } from 'react';
import { useTable } from 'react-table';

export default function Table({ columns, data, onRowClick, selectedRow }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });
  const tableContailerRef = useRef<HTMLDivElement>(null);
  const [isFocused] = useContainerFocus(tableContailerRef);

  useEventListener('keydown', (event: KeyboardEvent) => {
    //**
    // RFR: THIS CASE IS ONLY FOR IMAGING SCHEDULE, NEED TO REPLACE THIS WITH RMTABLE
    //  */
    if (!isFocused || !tableContailerRef.current) {
      return;
    }
    if (VerticalArrowKeys.includes(event.key as KeyboardKeys)) {
      const selectedRowIndex = selectedRow?.entryId
        ? data.findIndex((row) => row.entryId === selectedRow.entryId)
        : -1;
      const newIndex =
        event.key === KeyboardKeys.ArrowDown
          ? Math.min(selectedRowIndex + 1, data.length - 1)
          : Math.max(selectedRowIndex - 1, 0);
      const newRow = rows[newIndex]?.original;
      if (newRow) {
        onRowClick(newRow);
        const row = tableContailerRef.current.querySelector<HTMLTableRowElement>(
          `#tableData1_${newIndex}`,
        );
        if (row) {
          row.scrollIntoView({
            block: 'center',
          });
        }
      }
    }
  });
  return (
    <table
      id="imagingschedule-table"
      data-testid="imagingschedule-table"
      ref={tableContailerRef}
      className="imaging-table"
      style={{ width: '100%' }}
      {...getTableProps()}
    >
      <thead
        id="imagingschedule-thead"
        data-testid="imagingschedule-thead"
        style={{ position: 'sticky', top: 0 }}
      >
        {headerGroups.map((headerGroup, i) => (
          <tr
            id={`imagingschedule-headergroup-${i}`}
            data-testid={`imagingschedule-headergroup-${i}`}
            key={`imagingTable${i}`}
            {...headerGroup.getHeaderGroupProps()}
            className="height84"
          >
            {headerGroup.headers.map((column, index) => (
              <>
                <div className="th-sepration"></div>
                <th
                  data-testid={`imagingschedule-schedulingheader-${index}`}
                  {...column.getHeaderProps()}
                  className="schedulingHeader"
                >
                  {column.render('Header')}
                </th>
              </>
            ))}
          </tr>
        ))}
      </thead>
      <tbody
        id="imagingschedule-tbody"
        data-testid="imagingschedule-tbody"
        {...getTableBodyProps()}
      >
        {rows.map((row, i) => {
          prepareRow(row);
          const bgColor =
            row.original.dayNum === selectedRow.dayNum &&
            row.original.hourNum === selectedRow.hourNum &&
            row.original.entryId === selectedRow.entryId
              ? 'rgb(248, 151, 35)'
              : null;
          return (
            <tr
              id={`tableData1_${i}`}
              data-testid={`tableData1_${i}`}
              key={`tableData1_${i}`}
              {...row.getRowProps()}
              style={{ background: bgColor }}
              onClick={() => onRowClick(row.original)}
            >
              {row.cells.map((cell, index) => (
                <td
                  id={`imagingschedule-cell-${i}-${index}`}
                  data-testid={`imagingschedule-cell-${i}-${index}`}
                  key={`tableData_${index}`}
                  {...cell.getCellProps()}
                >
                  {cell.render('Cell')}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
